import * as React from "react";

function SvgPerson(props: React.SVGProps<SVGSVGElement>) {
  return (
<svg style={{ color: 'var(--brand, #382c83)' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" id="UserRecord">
  <g fill="currentColor" fill-rule="evenodd">
    <path d="M11.8501 2.875c-1.93297 0-3.49997 1.567-3.49997 3.5 0 1.933 1.567 3.5 3.49997 3.5 1.933 0 3.5-1.567 3.5-3.5 0-1.933-1.567-3.5-3.5-3.5zm-5.49997 3.5c0-3.03757 2.46243-5.5 5.49997-5.5 3.0376 0 5.5 2.46243 5.5 5.5 0 3.03757-2.4624 5.5-5.5 5.5-3.03754 0-5.49997-2.46243-5.49997-5.5zM11.2254 14.18c.0387.5509-.3766 1.0289-.9275 1.0675-2.34299.1645-4.65973.8104-6.7979 1.9378v3.6162h6.7279c.5523 0 1 .4477 1 1 0 .5523-.4477 1-1 1h-6.7279c-1.10457 0-2-.8954-2-2v-3.6719c0-.7055.38942-1.3534 1.01246-1.6845 2.40249-1.2767 5.00925-2.0076 7.64544-2.1927.5509-.0386 1.0289.3766 1.0675.9276z" fill="#000000"></path>
    <path fill="#1f00de" d="M17.5,14.125c-2.2091,0 -4,1.7909 -4,4c0,2.2091 1.7909,4 4,4c2.2091,0 4,-1.7909 4,-4c0,-2.2091 -1.7909,-4 -4,-4Zm-6,4c0,-3.3137 2.6863,-6 6,-6c3.3137,0 6,2.6863 6,6c0,3.3137 -2.6863,6 -6,6c-3.3137,0 -6,-2.6863 -6,-6Z"></path>
    <path fill="#1f00de" d="M15.5,18.125c0,-1.1046 0.8954,-2 2,-2c1.1046,0 2,0.8954 2,2c0,1.1046 -0.8954,2 -2,2c-1.1046,0 -2,-0.8954 -2,-2Z"></path>
  </g>
</svg>
  );
}

export default SvgPerson;
